/* eslint-disable react/prop-types,react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { Button, Grid, Segment, Icon, Accordion } from 'semantic-ui-react';
import { utils } from '@rjsf/core';
import { cleanClassNames, getSemanticProps, MaybeWrap } from './utils';
import AmsAlert from '../../../utils/AmsAlert';
import {
  exportEligiblilityFiles,
  exportTransactions,
} from '../../../actions/submissions';
import { useDispatch } from 'react-redux';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
const { isFixedItems } = utils;

const ArrayFieldTitle = ({ TitleField, idSchema, uiSchema, title }) => {
  if (!title) {
    return null;
  }

  const id = `${idSchema.$id}__title`;
  return (
    <TitleField
      id={id}
      className="array-title"
      title={title}
      options={uiSchema['ui:options']}
    />
  );
};

function ArrayFieldDescription({ DescriptionField, idSchema, description }) {
  if (!description) {
    // See #312: Ensure compatibility with old versions of React.
    return null;
  }
  const id = `${idSchema.$id}__description`;
  return (
    <DescriptionField
      id={id}
      className="array-description"
      description={description}
    />
  );
}

const gridStyle = vertical => ({
  display: 'grid',
  gridTemplateColumns: `1fr ${vertical ? 65 : 110}px`,
});

// checks if its the first array item
function isInitialArrayItem(props) {
  // no underscore because im not sure if we want to import a library here
  const { idSchema } = props.children.props;
  return idSchema.target && idSchema.conditions;
}

/*const [showDeleteAlert, setShowDeleteAlert] = useState(false);

const renderDeleteItemAlert = props => {
  return (
    <AmsAlert
      show={showDeleteAlert}
      title="Are you sure you want to delete this finding"
      text={`Are you sure you want to delete this finding`}
      type={'warning'}
      confirmButtonColor={'#112e51'}
      confirmButtonText={'Delete'}
      cancelButtonText={'Cancel'}
      showConfirm
      showCancelButton
      onCancel={() => {
        setShowDeleteAlert(false);
      }}
      onConfirm={() => {
        props.onDropIndexClick(props.index);
        setShowDeleteAlert(false);
      }}
    />
  );
};
 const [activeIndexes, setActiveIndexes] = useState([]);
  const handleAccordionClick = index => {
    setActiveIndexes(prevIndexes => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter(item => item !== index);
      } else {
        return [...prevIndexes, index];
      }
    });
  };*/

// Used in the two templates
function DefaultArrayItem(props) {
  return (
    <div className="array-item" key={props.key}>
      <div className="row">
        <div className="col-md-9">
          <h5 className="array-item-label">
            {props.itemLabel + ' ' + (props.index + 1)}
          </h5>
        </div>
        <div className="col-md-3">
          <div style={{ textAlign: 'right' }}>
            {props.itemLabel !== 'Funded Enrollment' &&
              props.hasToolbar &&
              props.hasRemove && (
                <Button.Group size="mini" vertical={false}>
                  {props.hasRemove && (
                    <Button
                      className="array-item-remove"
                      tabIndex="-1"
                      icon
                      size="tiny"
                      labelPosition="left"
                      disabled={props.disabled || props.readOnly}
                      onClick={props.onDropIndexClick(props.index)}
                      style={{
                        background: '#db2828',
                        color: '#fff',
                      }}
                    >
                      <Icon name="trash" />
                      Delete {props.itemLabel + ' ' + (props.index + 1)}
                    </Button>
                  )}
                </Button.Group>
              )}
          </div>
        </div>
      </div>
      <MaybeWrap wrap={props.wrapItem} component={Segment}>
        <Grid
          style={
            !isInitialArrayItem(props)
              ? { ...gridStyle(!props.horizontalButtons), alignItems: 'center' }
              : gridStyle(!props.horizontalButtons)
          }
        >
          <Grid.Column width={16} verticalAlign="middle">
            {props.children}
          </Grid.Column>
        </Grid>
      </MaybeWrap>
    </div>
  );
}

// Used for arrays that are represented as multiple selection fields
// (displayed as a multi select or checkboxes)
function DefaultFixedArrayFieldTemplate({
  uiSchema,
  idSchema,
  canAdd,
  className,
  classNames,
  disabled,
  items,
  onAddClick,
  readOnly,
  required,
  schema,
  title,
  TitleField,
  itemProps,
}) {
  const fieldTitle = uiSchema['ui:title'] || title;
  const fieldDescription = uiSchema['ui:description'] || schema.description;
  const itemLabel = schema.category || 'Item';
  return (
    <div className={cleanClassNames([className, classNames])}>
      <ArrayFieldTitle
        key={`array-field-title-${idSchema.$id}`}
        TitleField={TitleField}
        idSchema={idSchema}
        uiSchema={uiSchema}
        title={fieldTitle}
        required={required}
      />

      {fieldDescription && (
        <div
          className="field-description"
          key={`field-description-${idSchema.$id}`}
        >
          {fieldDescription}
        </div>
      )}

      <div key={`array-item-list-${idSchema.$id}`}>
        <div className="row array-item-list">
          {items &&
            items.map(p => DefaultArrayItem({ ...p, ...itemProps, itemLabel }))}
        </div>

        {canAdd && (
          <div
            style={{
              position: 'relative',
              textAlign: 'left',
            }}
          >
            <Button
              onClick={onAddClick}
              disabled={disabled || readOnly}
              icon
              size="tiny"
              labelPosition="left"
              style={{
                background: '#337ab7',
                color: '#fff',
              }}
            >
              <Icon name="plus" />
              Add {itemLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

function DefaultNormalArrayFieldTemplate({
  uiSchema,
  idSchema,
  canAdd,
  className,
  classNames,
  disabled,
  DescriptionField,
  items,
  onAddClick,
  readOnly,
  required,
  schema,
  title,
  TitleField,
  itemProps,
  formContext,
}) {
  const dispatch = useDispatch();
  const fieldTitle = uiSchema['ui:title'] || title;
  const fieldDescription = uiSchema['ui:description'] || schema.description;
  const itemLabel = schema.category || 'Item';
  const category = schema.category;
  const itemsPerPage = 10; // Number of items per page
  const start = currentPage * itemsPerPage;
  const end = start + itemsPerPage;
  const paginatedItems = items; //.slice(start, end);

  const totalPages = Math.ceil(items.length / itemsPerPage);

  const [activeIndexes, setActiveIndexes] = useState([0]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
  const [itemToDeleteHandler, setItemToDeleteHandler] = useState(null);

  const handleAccordionClick = index => {
    setActiveIndexes(prevIndexes => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter(item => item !== index);
      } else {
        return [...prevIndexes, index];
      }
    });
  };

  const renderDeleteItemAlert = () => (
    <AmsAlert
      show={showDeleteAlert}
      title="Confirm Deletion"
      text={`Are you sure you want to delete this ${itemLabel}? This action cannot be undone.`}
      type={'warning'}
      confirmButtonColor={'#112e51'}
      confirmButtonText={'Delete'}
      cancelButtonText={'Cancel'}
      showConfirm
      showCancelButton
      onCancel={() => {
        setShowDeleteAlert(false);
        setItemToDeleteHandler(null);
        setItemToDeleteIndex(null);
      }}
      onConfirm={() => {
        if (itemToDeleteHandler) {
          itemToDeleteHandler({ preventDefault: () => {} });
        }
        var newActiveIndexes = [...activeIndexes];
        newActiveIndexes = newActiveIndexes
          .filter(index => index !== itemToDeleteIndex)
          .map(index => (index > itemToDeleteIndex ? index - 1 : index));
        setActiveIndexes(newActiveIndexes);
        setShowDeleteAlert(false);
        setItemToDeleteHandler(null);
        setItemToDeleteIndex(null);
      }}
    />
  );

  const getTransactionCategoryLabel = (schema, formData) => {
    const key = 'txnCategory1';
    if (!schema?.properties?.[key]) return null;
    const { title, enum: enumValues, enumNames } = schema.properties[key];
    const selectedValue = formData?.[key];

    if (!selectedValue) {
      return '';
    }
    const index = enumValues.indexOf(selectedValue);
    if (index === -1) {
      return `${title}: ${selectedValue}`;
    }
    return `${enumNames[index]}`;
  };

  const getFileHeader = p => {
    return (
      <>
        <div>
          {itemLabel === 'Eligibility File'
            ? `${p.index + 1}. Child/Expectant Mother ID: ${p.children.props
                .formData.childId ?? ''}`
            : `${3}.${p.index + 1} Transaction: ${getTransactionCategoryLabel(
                p.children.props.schema,
                p.children.props.formData
              ) ?? ''}`}
        </div>
        <small
          style={{
            fontFamily: 'PublicSans-Regular',
            color: '#333',
            fontWeight: 'normal',
          }}
        >
          <span>{'Added by '}</span>
          <b style={{ color: '#000' }}>
            {p.children.props.formData.submittedBy != null
              ? p.children.props.formData.submittedBy
              : ''}
          </b>
          <span>{' on '}</span>
          <b style={{ color: '#000' }}>
            {p.children.props.formData.sbumittedIn != null
              ? p.children.props.formData.sbumittedIn
              : ''}
          </b>
        </small>
      </>
    );
  };
  let seenItems = [];
  return (
    <div
      className={cleanClassNames([
        className,
        classNames,
        'sortable-form-fields',
        category === 'Funded Enrollment' && 'funded-enrollment-labels',
      ])}
    >
      {renderDeleteItemAlert()}
      {'Follow-up' !== formContext?.reviewType && (
        <ArrayFieldTitle
          key={`array-field-title-${idSchema.$id}`}
          TitleField={TitleField}
          idSchema={idSchema}
          uiSchema={uiSchema}
          title={fieldTitle}
          required={required}
        />
      )}
      {fieldDescription && (
        <ArrayFieldDescription
          key={`array-field-description-${idSchema.$id}`}
          DescriptionField={DescriptionField}
          idSchema={idSchema}
          description={fieldDescription}
        />
      )}
      {['Finding', 'Eligibility File', 'Transaction'].includes(category) && (
        <div>
          {canAdd && (
            <div>
              {'Follow-up' !== formContext?.reviewType && (
                <Button
                  onClick={onAddClick}
                  disabled={disabled || readOnly}
                  icon
                  size="tiny"
                  labelPosition="left"
                  style={{
                    background: '#337ab7',
                    color: '#fff',
                    position: 'relative',
                    textAlign: 'left',
                  }}
                >
                  <Icon name="plus" />
                  Add {itemLabel}
                </Button>
              )}
              {['Eligibility File'].includes(category) &&
                items &&
                items.length > 0 && (
                  <Button
                    type="button"
                    onClick={() =>
                      dispatch(exportEligiblilityFiles(formContext.answerId))
                    }
                    icon
                    disabled={disabled || readOnly}
                    size="tiny"
                    primary
                    content="Export Files"
                    style={{
                      background: '#337ab7',
                      color: '#fff',
                      float: 'right',
                      position: 'relative',
                    }}
                  ></Button>
                )}
              {['Transaction'].includes(category) && items && items.length > 0 && (
                <Button
                  type="button"
                  onClick={() =>
                    dispatch(exportTransactions(formContext.answerId))
                  }
                  icon
                  disabled={disabled || readOnly}
                  size="tiny"
                  primary
                  content="Export Files"
                  style={{
                    background: '#337ab7',
                    color: '#fff',
                    float: 'right',
                    position: 'relative',
                  }}
                ></Button>
              )}
            </div>
          )}
          <br />
          {'Follow-up' !== formContext?.reviewType ? (
            <Accordion fluid>
              <div>
                {paginatedItems &&
                  paginatedItems.map((p, index) => {
                    var seen = false;
                    if (
                      ['Finding', 'Eligibility File', 'Transaction'].includes(
                        category
                      )
                    ) {
                      if (
                        p.children.props.formData &&
                        !p.children.props.formData.uuid
                      ) {
                        p.children.props.formData.uuid = uuidv4();
                      }
                    }
                    if (
                      ['Finding', 'Eligibility File', 'Transaction'].includes(
                        category
                      )
                    ) {
                      if (p.children.props.formData.childId)
                        if (
                          seenItems.includes(p.children.props.formData.childId)
                        )
                          seen = true;
                        else seenItems.push(p.children.props.formData.childId);
                    }
                    return (
                      <div key={index}>
                        <Accordion.Title
                          active={activeIndexes.includes(index)}
                          index={index}
                          style={{ backgroundColor: '#DCDCDC', marginTop: 20 }}
                          onClick={() => handleAccordionClick(index)}
                        >
                          <h3 style={{ margin: '0px 15px' }}>
                            {' '}
                            {['Eligibility File', 'Transaction'].includes(
                              category
                            )
                              ? getFileHeader(p)
                              : itemLabel +
                                ' ' +
                                (p.index + 1) +
                                '-' +
                                ' Citation' +
                                ' ' +
                                (p.children.props.formData.CitationPicker !=
                                null
                                  ? p.children.props.formData.CitationPicker
                                  : '')}
                            <Icon
                              style={{
                                float: 'right',
                                marginTop: [
                                  'Eligibility File',
                                  'Transaction',
                                ].includes(category)
                                  ? '-10px'
                                  : '0px',
                              }}
                              name={
                                activeIndexes.includes(index) ? 'minus' : 'plus'
                              }
                            />
                          </h3>
                        </Accordion.Title>
                        <Accordion.Content
                          active={activeIndexes.includes(index)}
                          style={{ marginTop: '20px' }}
                        >
                          {seen ? (
                            <Alert bsStyle="danger">
                              Child/Expectant Mother ID{' '}
                              {p.children.props.formData.childId} is duplicated.
                            </Alert>
                          ) : (
                            <></>
                          )}
                          {p.hasToolbar && p.hasRemove && (
                            <Button.Group
                              size="mini"
                              vertical={false}
                              style={{
                                float: 'right',
                                marginTop: '-15px',
                              }}
                            >
                              {p.hasRemove && (
                                <Button
                                  className="array-item-remove"
                                  tabIndex="-1"
                                  icon
                                  size="tiny"
                                  labelPosition="right"
                                  disabled={p.disabled || p.readOnly}
                                  onClick={e => {
                                    e.preventDefault();
                                    setItemToDeleteIndex(p.index);
                                    setItemToDeleteHandler(() =>
                                      p.onDropIndexClick(p.index)
                                    );
                                    setShowDeleteAlert(true);
                                  }}
                                  style={{
                                    background: '#db2828',
                                    color: '#fff',
                                  }}
                                >
                                  <Icon name="trash" />
                                  Delete{' '}
                                  {category === 'Eligibility File' ? (
                                    <>
                                      {p.index + 1}. Child/Expectant Mother ID:{' '}
                                      {p.children.props.formData.childId ?? ''}
                                    </>
                                  ) : category === 'Transaction' ? (
                                    <>
                                      3.{p.index + 1}. Transaction:{' '}
                                      {getTransactionCategoryLabel(
                                        p.children.props.schema,
                                        p.children.props.formData
                                      ) ?? ''}
                                    </>
                                  ) : (
                                    <>
                                      {itemLabel} {p.index + 1}
                                    </>
                                  )}
                                </Button>
                              )}
                            </Button.Group>
                          )}
                          {p.children}
                        </Accordion.Content>
                      </div>
                    );
                  })}
              </div>
            </Accordion>
          ) : (
            <div style={{ marginTop: '-20px', display: 'block' }}>
              {paginatedItems &&
                paginatedItems.map((p, index) => {
                  return p.children;
                })}
            </div>
          )}
        </div>
      )}
      {!['Finding', 'Eligibility File', 'Transaction'].includes(category) && (
        <div key={`array-item-list-${idSchema.$id}`}>
          <div className="row array-item-list">
            {items &&
              items.map(p =>
                DefaultArrayItem({ ...p, ...itemProps, itemLabel })
              )}
          </div>

          {canAdd && category !== 'Funded Enrollment' && (
            <div
              style={{
                position: 'relative',
                textAlign: 'left',
              }}
            >
              <Button
                onClick={onAddClick}
                disabled={disabled || readOnly}
                icon
                size="tiny"
                labelPosition="left"
                style={{
                  background: '#337ab7',
                  color: '#fff',
                }}
              >
                <Icon name="plus" />
                Add {itemLabel}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function ArrayFieldTemplate(props) {
  const { options, schema, uiSchema, formContext } = props;
  const semanticProps = getSemanticProps({
    options,
    uiSchema,
    formContext,
    defaultSchemaProps: { horizontalButtons: false, wrapItem: false },
  });
  const { horizontalButtons, wrapItem } = semanticProps;
  const itemProps = { horizontalButtons, wrapItem };
  if (isFixedItems(schema)) {
    return (
      <div>
        <DefaultFixedArrayFieldTemplate {...props} itemProps={itemProps} />
      </div>
    );
  }
  return (
    <div>
      <DefaultNormalArrayFieldTemplate {...props} itemProps={itemProps} />
    </div>
  );
}

export default ArrayFieldTemplate;
